import 'devextreme/dist/css/dx.common.css';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';

loadMessages(ruMessages);
locale(navigator.language);
